module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm2",
    attrs: {
      "id": "page_14"
    }
  }, [_c('em', {
    staticClass: "calibre9"
  }, [_vm._v("Day One")])]), _vm._v(" "), _c('p', {
    staticClass: "fm3"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATURE AND")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HARACTER OF")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD")])]), _vm._v(" "), _c('p', {
    staticClass: "fm4"
  }, [_c('em', {
    staticClass: "calibre3"
  }, [_vm._v("And God said, “Let there be light,” and there was light . . . and there was evening and there was morning—the first day . . . ")])]), _vm._v(" "), _c('p', {
    staticClass: "fm5"
  }, [_c('em', {
    staticClass: "calibre3"
  }, [_vm._v("And God saw that it was good")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("All spiritual inquiries must begin by asking certain important questions. The right questions provide a foundation for the scriptural quest that follows. These give focus to the truth we seek. Beginning our inquiry at the Source clarifies that an understanding of God’s Will at every level must proceed out of God’s intrinsic nature and essential character.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Clearly an inquiry into what we call God’s Will begins with God "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("himself")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("All truth begins with a right knowing of God. If we don’t know what God is like, living in his Will will always be a closed book to our understandings.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("“Who "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("is")]), _vm._v(" God?” is the foremost of all foundational questions.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("From this flow several related questions:")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_c('em', {
    staticClass: "calibre3"
  }, [_vm._v("What is God like? What is his nature, his character, his personality? What kinds of things does he do? How does he work?")])]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("From these initial questions then proceeds the question that forms the heart of our present discussion:")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("“What are God’s "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("purposes")]), _vm._v("? What is it that God "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("wants")]), _vm._v(" to do? What is he trying to "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("accomplish")]), _vm._v(" in his creation?” In other words . . . what is his "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("Will")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("We cannot even begin to approach the question, “What does God want for "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("me")]), _vm._v("?” without knowing who God is and how he works.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("These are far from abstract doctrinal issues. They form the heart and soul of daily practical living for anyone serious about his or her spiritual life.")]), _vm._v(" "), _c('p', {
    staticClass: "toc_entry2"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("AN UNSETTLING CHALLENGE")])]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Most of us do not have as clear a picture of who God is and what are his purposes as we think. Some may set this book aside right now rather than challenge themselves to take that statement to the mirror of their own prayer closet. Yet the sad fact is, from our spiritual infancies we are taught in the various doctrinal catechisms of our particular orthodoxies about God. (Evangelicals, Pentecostals, Presbyterians, and Baptists all have their learned catechisms as surely as do Catholics.) By the time we are one or two years old in the faith, we assume that we possess a full and accurate knowledge of God and his ways.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("But what if the teaching and its doctrinal assumptions about God are incomplete, or even in error at certain points?")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Many will not want to face the unsettling possibility that their knowledge of God and his ways is either incomplete or erroneous. It goes against the teaching. It strikes at the very root of their orthodoxy which maintains full knowledge of truth.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("But . . . "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("what if")]), _vm._v(" God has more of himself to reveal than has been included in the teaching we have received? "), _c('sup', {
    staticClass: "calibre11"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/text/part0026",
      "id": "id_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("The practicality of this inquiry can be seen at once by a dozen examples.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Is God’s primary purpose "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("corporate")]), _vm._v(" or "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("individual")]), _vm._v("? Is the church or one’s individual walk with God the primary means by which God reveals his truth? There are differing views. Most would no doubt say the truth is represented by a combination of both. But the question for our immediate purpose is: Do our perspectives flow out of what we observe in God "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("himself")]), _vm._v(" . . . or in the teaching we have received?")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Have we stopped to consider the nature of the Christian walk in light of God’s essential being? Most probably haven’t. We have been taught certain doctrines about the church and about spirituality, but in general these have not proceeded out of an inquiry into the nature of God himself. They have been taught us for other reasons.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("Is God by nature a "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("judge")]), _vm._v(" or a "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("father")]), _vm._v("? If a judge, is he a judge of leniency and forgiveness, or a judge of retribution and punishment? If a father, is he a father of tolerance and understanding, or a father who demands nothing short of perfect obedience? Again . . . there are differing views, and most would no doubt say the truth is represented by a combination of both. But again the important question is: Do our perspectives flow out of what we observe in God "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("himself")]), _vm._v(" . . . or in the teaching we have received?")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Is God by nature a distant almighty authoritarian "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("autocrat")]), _vm._v(", or an approachable "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("friend")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Does God’s nature as revealed in the Father and the Son represent a "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("unity of purpose")]), _vm._v(", or do Father and Son "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("differ")]), _vm._v(" in their essential roles toward mankind?")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Do we really know God’s nature and purposes as thoroughly as we think?")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("We have been "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("taught")]), _vm._v(" much. Most of us have not inquired with great depth, however, into the nature and being of God himself to see if the teachings we have received in fact flow from the essence of who God is.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("It is little wonder that our ideas of what comprise “God’s Will” are sketchy and incomplete, even contradictory. Most Christians have not founded their beliefs on a deep and prayerful quest to know God’s nature and character.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("This is "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("the")]), _vm._v(" essential starting point.")]), _vm._v(" "), _c('p', {
    staticClass: "toc_entry2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CREATING FATHER OF LIFE")])]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("To cut through the fog of uncertainty and the haze of incomplete teaching, we must first address the fundamental question: "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("Who is God?")])]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Many will begin mentally reeling off lists of learned attributes by which they have been accustomed to “define” God’s being. These mostly originate out of teachings that have been handed down to us by the traditions of our elders, not from a personal quest of discovery. Such defining lists will include attributes such as: God is holy, God is just, God is omnipotent, God is omnipresent, God is righteous, God is good, God is incomprehensible, God is sovereign, God is self-existent . . . and many others.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("But a list of abstract and learned “characteristics” does not identify God’s essence, his being, his personality, his purpose. Holiness or righteousness or incomprehensibility or judgment tell us nothing about what God is actually "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("like")]), _vm._v(" . . . or, if we can say it this way, what he is actually like "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("as a person")]), _vm._v(". We must come at the question "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("Who is God?")]), _vm._v(" from another direction than a list of attributes from a theological textbook.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("To put it bluntly and practically . . . if I walked into a room for a one-on-one chat in two comfortable easy chairs with God, what would he be like as he talked to me? What would be his manner? How would he treat me? Would he immediately start rebuking me for my sins and shortcomings . . . or would he have a welcoming smile on his face and greet me warmly and say, “Come in, come in . . . sit down . . . it’s great to see you face-to-face at last!”")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("The answer we seek is simple and clear. Yet the obvious truth has sadly "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("not")]), _vm._v(" been the foundational cornerstone of Christian teaching.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_c('em', {
    staticClass: "calibre3"
  }, [_vm._v("God is the creating Father of life and the universe")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Those ten words seem simple enough. They will probably not at first glance strike you as amazing, revolutionary, or new.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("But read them over two or three times . . . slowly . . . prayerfully. Let them sink into your heart for a few moments. You may just find them gradually turning your “theology” of God’s nature—and therefore your understanding of his Will—upside down.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("God is a creating life-creating, love-creating, goodness-creating "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("Father")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("A holy and omnipotent judge cannot produce life. That God may be holy and omnipotent and sovereign and righteous does not raise such attributes to the level of "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("essence")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Only “fatherhood” can define that essence. It is in fatherhood that the seed of essential "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("life")]), _vm._v(" gives birth to "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("new")]), _vm._v(" beings, "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("new")]), _vm._v(" worlds, "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("new")]), _vm._v(" universes . . . "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("new")]), _vm._v(" life. A judge dispenses judgment but cannot create. Only a father can create new beings.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("God’s essential being is “creative” and “procreative.” It gives "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("life")]), _vm._v(" to offspring that are like himself—created in his image. One can speak of God’s "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("power")]), _vm._v(" to create—his almighty omnipotence. But sheer power falls short of the capacity to “father” . . . or of "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("fathering")]), _vm._v(" love and goodness.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("Genesis 1, the foundation of foundations, does not speak of judgment, holiness, sovereignty, omnipresence, or righteousness. It speaks of essential "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("origination")]), _vm._v(" and "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("procreation")]), _vm._v(" of life. By his essential self, God "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("fathered")]), _vm._v(" the universe and all that is in it.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("The "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("Fatherness")]), _vm._v(" of God is the essential essence and life of the universe. It is the only and basic originating thing. What existed "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("before")]), _vm._v(" the big bang, "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("before")]), _vm._v(" Satan’s fall, "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("before")]), _vm._v(" matter and energy came into being, "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("before")]), _vm._v(" Genesis 1:1?")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("The Fatherness of God’s essential self.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("This Fatherhood-core of God’s essence should hardly surprise us. It is exactly what Jesus told us that God was, and is. Yet remarkably, considering the clarity with which Jesus described his own relationship to this originating Fatherness, the divine Fatherhood has "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("not")]), _vm._v(" provided the basis for essential Christian teaching about God. Indeed, Christian orthodoxy has taught almost everything about God "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("except")]), _vm._v(" his Fatherhood.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("And because everything in that fathered creation was good—indeed, "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("very")]), _vm._v(" good!—and as it proceeded out of the fathering essence and foundation of the universe, by simple cause and effect we can deduce that God’s essential character is also good.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("In these few simple observations of the Genesis account, we have already penetrated more deeply into the nature of God’s being and purposes than most Christian “theologies” that have been devised through the centuries:")]), _vm._v(" "), _c('p', {
    staticClass: "toc_entry2"
  }, [_c('em', {
    staticClass: "calibre3"
  }, [_vm._v("God is the fathering Life of the universe and all that is in it."), _c('br', {
    staticClass: "calibre6"
  }), _vm._v("\nHe is a good Father."), _c('br', {
    staticClass: "calibre6"
  }), _vm._v("\nHis ultimate intent for his creation must therefore be goodness")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("When I sit down for my imaginary chat with God, then, what I find is a "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("Father")]), _vm._v(" . . . a Father who loves me!")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("The almighty Judge of incomplete theologies, sitting on his divine throne of retribution, already begins to look a little less fearsome. One wonders if perhaps his Will and purpose for the universe might be more far reaching than certain judicial doctrines of holiness have led us to expect.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_c('em', {
    staticClass: "calibre3"
  }, [_vm._v("Genesis 1 reveals the Fatherhood of God")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("It reveals the "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("goodness")]), _vm._v(" of that Fatherhood.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("And it reveals goodness as the "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("ultimate purpose")]), _vm._v(" and intent of the Father-God’s creation.")]), _vm._v(" "), _c('p', {
    staticClass: "toc_entry2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("GOD")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S ESSENTIAL BEING")]), _vm._v(": "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A TRINITY OF FOUNDATIONAL ATTRIBUTES")])]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Now while God may be all those things we noted a moment ago—almighty, omnipotent, holy, righteous, etc., we have to be very careful to distinguish the "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("foundational")]), _vm._v(", the first, the primary, the essential characteristics of his being.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("When we begin looking at foundations, it is a very short list according to the revelation we have been given. There are only two places in Scripture where God’s essential nature is "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("defined")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Those two passages are 1 John 4:8 and Exodus 3:14.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("We know that, of all his attributes, God’s love is paramount. Love is what he "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("is")]), _vm._v(". Love is his defining characteristic, his essence.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_c('em', {
    staticClass: "calibre3"
  }, [_vm._v("God IS love")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("That Love, of course, is occasionally “tough love”—love that disciplines, love with authority to command and compel obedience, sometimes through stringent means. But "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("Love")]), _vm._v(" remains ever and always at the foundation.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("In addition, we are told, through God’s own mouth, that he is existence itself. He is "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("life")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_c('em', {
    staticClass: "calibre3"
  }, [_vm._v("I am that I am")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("These two passages define God’s foundational being: Love and existence.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("By implication this leads us to a third essential characteristic—God’s nature is also "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("infinite")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("If "), _c('span', {
    staticClass: "small"
  }, [_vm._v("I AM")]), _vm._v(" has existed "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("from")]), _vm._v(" all eternity (without beginning) and will exist "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("to")]), _vm._v(" all eternity (without end), if God’s “beingness” is unending in both directions, then it is an existence that, by definition, is infinite and eternal. That’s what “infinite” is—without end in all directions.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("God’s being is thus defined as “fathering love and eternal existence”—"), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("infinite life, infinite love")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("We can observe, therefore, a “trinity” of characteristics that define God’s essential being and existence:")]), _vm._v(" "), _c('p', {
    staticClass: "fm6"
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATHERING")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVE")])]), _vm._v(" "), _c('p', {
    staticClass: "fm6"
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATHERING")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFE")])]), _vm._v(" "), _c('p', {
    staticClass: "fm6"
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TERNAL")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATHERHOOD")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("God is life. God is love. God is eternal.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Following this logically (if A . . . then B), we can conclude that, as God himself in his foundational nature "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("is")]), _vm._v(" Infinity, all his attributes must likewise be infinite and without end.")]), _vm._v(" "), _c('p', {
    staticClass: "toc_entry2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NOT EVERYTHING IS FOUNDATIONAL")])]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Clearly God possesses many attributes and characteristics. All may be “infinite,” but not all are “foundational.” Many attributes of God’s nature may be eternal but not in themselves “defining” of his "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("essence")]), _vm._v(". Though it is absurd to speak of ranking God’s attributes in order of importance if all are infinite, there is a sense in which, to understand God aright, we must be aware of what is "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("foundational "), _c('span', {
    staticClass: "small"
  }, [_vm._v("IN")]), _vm._v(" his nature")]), _vm._v(", and what "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("proceeds "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUT OF")]), _vm._v(" that nature")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Some may argue against it being said that God’s holiness, for instance, does not rise to the level of an essential and foundational characteristic of his nature. But it is clear that, while infinite, his holiness proceeds "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("out of")]), _vm._v(" the essential three. Holiness is not "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("in itself")]), _vm._v(" a self-existent "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("defining")]), _vm._v(" characteristic of God’s being. It is because God is infinite in love that holiness is characteristic of his essential being. His holiness is a by-product of his infinite love—a fact that reveals the bankruptcy of a theology which insists that because of his holiness, God is forced to do things that infinite love would never do. The secondary attribute (holiness) cannot rise above the primary attribute (infinite Love.)")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("God said to Moses, “The place where you are standing is holy ground.” Clearly, if his presence produced holiness in that place, holiness was included in his divine nature. But it was a holiness proceeding "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("out of")]), _vm._v(" his infinite Life and beingness.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("God did not say, "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("I am holy, that I am holy")]), _vm._v(". It was merely "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("I am that I am")]), _vm._v(". Eternal existence (infinite fathering Life) was primary to his being, not holiness. It was not by holiness (or righteousness or omnipotence or justice) that he chose to identify himself. These are "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("attributes")]), _vm._v(" of that being, not "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("definitions")]), _vm._v(" of it.")]), _vm._v(" "), _c('p', {
    staticClass: "toc_entry2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CAUSATIVE FOUNDATIONS")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("RESULTANT ATTRIBUTES")])]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("This is far more than splitting hairs. This is an extremely significant truth. We must begin with absolute eternal "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("foundations")]), _vm._v(". Understanding God’s Will at any subsequent level proceeds out of those foundations.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("It is with some hesitation that I speak thus, perhaps implying that there are primary and secondary aspects to God’s nature. This is in one sense misleading. No attribute of God can be “secondary” if all are infinite. Yet the principle of origins and foundations is so crucial to understanding God’s nature that if kept in balance the primary/secondary distinction may be helpful.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("It would perhaps be more useful to differentiate between "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("Causative")]), _vm._v(" attributes (those that “cause” and inform and produce and give life to the others), and "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("Resultant")]), _vm._v(" attributes (those that proceed and emerge out of the foundational three.)")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("God’s "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("holiness")]), _vm._v(", as we have seen, is just such a resultant attribute of his nature. It results "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("from")]), _vm._v(" who God is, but is not in and of itself a causative and primary attribute of his being. God’s holiness is "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("infinite")]), _vm._v(", but it is not "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("causative")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("God’s "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("creativity")]), _vm._v(" results from his Eternal Life and Love. Being infinite in life, he creates more life. Thus the universe came into being. The creation does not define who God is of itself, it has proceeded out of God’s threefold causative nature. It "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("reveals")]), _vm._v(" but does not "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("define")]), _vm._v(". His being as “Creator” is the inevitable outflow of the "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("Life")]), _vm._v(" that defines his essential being.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("God’s "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("goodness")]), _vm._v(", likewise, results out of God’s nature. If everything to which God set his hand is good, we can deduce that God himself is good. But we are not told that God’s being is "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("defined")]), _vm._v(" by goodness, only that goodness "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("results")]), _vm._v(" when Love creates. Goodness, then, must be an attribute of God’s nature, but in a resultant rather than a causative sense.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("God’s "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("forgiveness")]), _vm._v(", too, is a resultant attribute of his nature. It results from God’s Love. God’s forgiveness is infinite and eternal, but it is not causative.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("We could enumerate a hundred such qualities and characteristics which contribute to God’s multi-dimensioned personality. All together they complete the picture of his character and being and give scope to our understanding of his purpose and Will. They all proceed "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("out of")]), _vm._v(" these foundations and must therefore harmonize consistently "), _c('a', {
    staticClass: "calibre4",
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("with them.")]), _vm._v(" "), _c('p', {
    staticClass: "toc_entry2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("BEGINNING WITH RESULTS LEADS TO ERROR")])]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Whenever the attempt is made to place a "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("resultant")]), _vm._v(" attribute of God into the foundational role occupied by these "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("causative")]), _vm._v(" three ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("FATHERING LIFE")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FATHERING LOVE")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETERNAL FATHERHOOD")]), _vm._v(") error follows.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Many theological edifices, for example, have been built on foundations of holiness and justice. Because these attributes of God are mistakenly interpreted as causative, erroneous doctrines have grown up around them. From misunderstood foundations emerge incomplete doctrines.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Many examples could be cited to illustrate misunderstandings of God’s Will based on faulty assumptions about his nature and being. Disconnected theological thinking can lead to tragic results because unthinking Christians swallow inconsistencies about God without batting an eye, trying to understand God’s Will on the basis of non-causative attributes of his nature where the dots of scriptural progressivity are ignored.")]), _vm._v(" "), _c('p', {
    staticClass: "toc_entry2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("RESULT OF IMPLICATIONAL THINKING ROOTED IN THE NATURE OF GOD")])]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("As simply one example, we are told in Scripture that it is “God’s Will” that none should perish. We have no choice but to take this as a major statement of God’s purpose. From it we go back to the starting point—God’s essential nature—and see that God is Infinite and Eternal. Therefore, is it conceivable that God’s “Will” will "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("not")]), _vm._v(" be accomplished in the end?")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("This is so imperative a query that it bears repeating: Is it possible for God’s Will to be thwarted by sin and that sinners will be able to eternally choose separation from their Creator? And yet does not this violate one of God’s essential characteristics—Infinity?")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Many theologies are built on a supposed framework that God’s Will is for all creation to be perfect, for it to be in fellowship with him, that none should be separated from him, and that none should perish . . . but that in the end none of those purposes will be fully accomplished. They are built, in other words, upon a foundation "), _c('a', {
    staticClass: "calibre4",
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("which maintains that in the end, eternally, God’s Will will ultimately be thwarted.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Again we must ask: If God is infinite, is this conceivable?")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("God’s eternal Will, if he is infinite, "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("must")]), _vm._v(" be accomplished. Otherwise his infinity is undone.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("How is it then that so much of theology is spent devising contorted scriptural reasons to explain why in the end God’s eternal Will will "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("not")]), _vm._v(" be accomplished? It is an amazing thing when you think about it, that much Christian teaching consists in the devising of theological slip-knots that justify God’s supposed sovereignty in light of this glaring dichotomy.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("It is as clear as "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("If A . . . then B")]), _vm._v(". If God is infinite . . . his Will "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("must")]), _vm._v(" be accomplished.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("God’s "), _c('span', {
    staticClass: "small"
  }, [_vm._v("WILL")]), _vm._v(" will be done.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Progressing a step further and connecting two more dots, if it is God’s will than none perish, and his Will must be accomplished, then "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("no one can perish")]), _vm._v(". If A . . . then B . . . then C.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Does this not invalidate the doctrine that at some point the souls of unrepentant sinners will be exterminated and forever destroyed from the face of heaven and earth.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("It is an admirable doctrine for dealing with hell. But if you go all the way back to foundations, to the nature and character of God himself—Life, Love, Eternal—annihilation as a doctrine cannot be true. "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("Infinite fathering life")]), _vm._v(" and "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("infinite fathering love")]), _vm._v(" cannot, by the eternal infinity of his life-creating nature, "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("destroy")]), _vm._v(" life. Two contradictory qualities cannot both be operative in the divine nature—life creating and life destroying—if his is an "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("infinite")]), _vm._v(" nature. God did not "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("destroy")]), _vm._v(" Adam and Eve for their sin, he "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("created")]), _vm._v(" a means for their redemption. God is always in the process of creating more life, not destroying it.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("We still have not unraveled the mystery of "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("how")]), _vm._v(" God will eternally deal with sin. We have only eliminated one possibility by recognizing that God’s nature (Infinite "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("unending")]), _vm._v(" Life) precludes annihilation. It may often be this way. God has intentionally kept from us exactly what is his Will concerning the afterlife and eternity. Why? Who can say? His revelation concerning the afterlife is partial, incomplete, and shadowy.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("Error compounds error. We now have generation upon generation of Christians who do not understand God’s Will in their own lives, because they do not understand God’s Will for mankind, because they do not understand God’s eternal Will for the universe . . . all because they have not understood the foundational essence of who God is.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("God is the eternal fathering Creator of Life and Infinite in Love.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("To understand God’s Will one must begin at the right place.")]), _vm._v(" "), _c('p', {
    staticClass: "toc_entry2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("GOD")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S FOUNDATIONAL PURPOSE FOR HIS CREATURES")])]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Those who have been taught that God is only the Father of the “saved” or the “elect” have been wrongly and unscripturally taught. Those who have been taught that God "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("becomes")]), _vm._v(" our Father through salvation have been wrongly taught. God is the Father of "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("all")]), _vm._v(" life, "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("all")]), _vm._v(" creation, "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("all")]), _vm._v(" mankind. He is the Father of "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("both")]), _vm._v(" his wayward and his obedient children. To be properly understood, salvation must be seen as the homecoming of the prodigal. He is the Father of all, and is a good Father to all. As George MacDonald says, “Because we are his children, we must become his sons and daughters.” "), _c('sup', {
    staticClass: "calibre11"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/text/part0026",
      "id": "id_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("If God has expressed and revealed his being by fathering a creation and by fathering creatures in his own image, his foundational purpose for that creation must involve those offspring. His first and only begotten Son, who according to John participated in the creation itself, is the first of many sons and daughters. The mystery of the Godhead reveals the foundational purpose or “Will” of God—first the creation of children, and then the growth of those children into obedient sons and daughters so that they might share in the "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("Life")]), _vm._v(" that was fathered into the universe in the beginning, the Life that exists in the unity between the Father and the Son.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("What is the nature of that "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("Life")]), _vm._v("? What is the sonship to which the Fatherhood of the universe calls his creation?")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("It is a sonship revealed in Jesus Christ himself. He is the prototypical example and life-giving creative source of responsive and obedient Life. The two personalities—Father and Son—within the Godhead, and the Spirit of life existing between them and joining "), _c('a', {
    staticClass: "calibre4",
    attrs: {
      "id": "page_25"
    }
  }), _vm._v("them, make one essential Life of unity into which we are both called and commanded to participate.")]), _vm._v(" "), _c('p', {
    staticClass: "toc_entry2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FASHIONING SONS AND DAUGHTERS")])]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Understanding neither the Fatherhood of Genesis 1, nor the Sonship of the four gospels, and wrongly taught by doctrinal orthodoxies about both, many Christians spend their lives on the periphery of God’s purpose and never realize it.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Many secondary aspects of God’s will are good, right, and scriptural elements of spirituality with which we should be concerned. We do well to understand these, and to pray for God to develop them within us. Books and sermons and Bible studies and conferences by the hundreds of thousands focus on this multitude of secondary things every day as we devote a lifetime of energy to various lesser elements of spirituality.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("But what is God’s "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("primary")]), _vm._v(" Will for his people?")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Are “blessings” God’s highest desire for us? Is spiritual “knowledge” and “study” to be our supreme spiritual focus? Is sharing the love of God with others the highest priority?")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("What is it that God wants to do in your life, and in mine, above "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("all")]), _vm._v(" other things?")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("What is the "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("summum bonum")]), _vm._v(", the greatest thing, the “supreme good” of life—the most perfect, ultimate purpose that is in God’s mind and heart when he thinks of "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("you")]), _vm._v(" and "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("me?")]), _vm._v(" What would God say, sitting across from me in that imaginary room, looking me in the eye, and saying: “"), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("This")]), _vm._v(" is what I want for you. "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("This")]), _vm._v(" is my plan for you. "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("This")]), _vm._v(" is my will for you. "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("This")]), _vm._v(" is what I intend to accomplish in your life from now through eternity.”")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("It can be simply stated: That we become sons and daughters of the Father of the universe—sons and daughters who are conformed to the image of Christ.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("He would say to each one of us, “I want you to be fully my son . . . my daughter.”")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Jesus was "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("the")]), _vm._v(" Son of God, the “only begotten” Son. God’s intent and Will is that we too become sons and daughters, his younger brothers and sisters, who are "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("like")]), _vm._v(" him—who love like him, think like "), _c('a', {
    staticClass: "calibre4",
    attrs: {
      "id": "page_26"
    }
  }), _vm._v("him, respond like him, resist the enemy like him, trust the Father like him, and who pray like him.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("We will never be like him in his perfection. But we "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("are")]), _vm._v(" to become like him in attitude, thought, and motive. Only "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("one")]), _vm._v(" Son brought salvation to the world. But "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("all")]), _vm._v(" God’s sons and daughters are not merely to partake of that salvation, but to "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("fulfill")]), _vm._v(" it by growing into the Christlikeness that it makes possible.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("To turn us into the kind of people who "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("can")]), _vm._v(" do so—with infinitesimally tiny baby steps to begin with, then growing steadily more capable of it as our lives progress—is the whole point of Christianity. There is simply nothing else that the Christian life is about. We will never do so perfectly in this life. But it is toward this end that God means to take us. It is toward this divine “center” that our exploration of God’s Will leads us.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Such a transformation into men and women that reflect the nature of Jesus Christ is not something that can be accomplished externally, with bumper stickers or worship services or thirty day programs.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("The sonship and daughterhood that is God’s Will to accomplish will not come about by outward manifestation. It can only happen inwardly, as we become people of a certain nature and character.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("God wants more than mere believers. He wants more than mere worshippers, more than faithful “churchmen” and “churchwomen.” He wants more than people who can parrot back doctrinally correct spiritual phrases. He wants more than men and women forever seeking new spiritual experiences and highs and blessings.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("He is involved in the enterprise of fashioning humble Christlike sons and daughters.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("In the same way that he stooped down and created Adam and Eve out of the dust of the ground, he similarly takes each one of us when we give our lives to him, takes us in the midst of our sinful and selfish natures, and to the extent we yield to that remaking process, as with our ancient ancestors in Eden, begins to fashion children who will one day bear the image and reflect the nature of his firstborn Son, Jesus Christ himself.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_c('em', {
    staticClass: "calibre3"
  }, [_vm._v("That")]), _vm._v(" is the essence of God’s will for you and me.")]), _vm._v(" "), _c('div', {
    staticClass: "c"
  }, [_c('p', {
    staticClass: "toc_entry2"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "id": "page_27"
    }
  }), _vm._v("GOD")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S CHARACTER AND BEING"), _c('br', {
    staticClass: "calibre6"
  })]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFE")]), _vm._v("-L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVE")]), _vm._v("-I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NFINITE")])]), _vm._v(" "), _c('p', {
    staticClass: "fm7"
  }, [_vm._v("Perfect, Creative, Good, Holy, Forgiving, Righteous, Trustworthy, Just, Personal, Pure, Merciful, True, Almighty, Omnipotent, Patient, Omniscient, Unchanging, Kind, Omnipresent")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53e4dfce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/part0006.vue
// module id = 78
// module chunks = 0